import { useTranslation } from "../../../../state/i18n";
import { useCustomerState } from "../../../../state/customer";
import Text from "../../../../components/text/Text";
import moreappIcon from "../../../../assets/moreapp-icon-solid.svg";

const ActiveCustomerInfo = () => {
  const { t } = useTranslation();
  const customer = useCustomerState();

  return (
    <div class="flex w-68 items-center gap-2 pr-2 pl-4.5">
      <img class="size-8 rounded-sm" src={moreappIcon} alt={t(($) => $.MOREAPP_LOGO_IMG_ALT)} />
      <div class="flex flex-col gap-0.5 overflow-hidden">
        <Text as="h2" class="text-header-md text-primary" text={customer.name} truncate />
        <span class="text-small-regular text-secondary">{customer.customerId.toString()}</span>
      </div>
    </div>
  );
};

export default ActiveCustomerInfo;
